"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.READY = exports.CALL_API = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importStar(require("react"));
const client_1 = require("react-dom/client");
const axios_1 = __importDefault(require("axios"));
const SearchBar_1 = __importDefault(require("../components/SearchBar"));
const FilterSort_1 = __importDefault(require("../components/aircraft-register/FilterSort"));
const FilterGroup_1 = __importDefault(require("../components/aircraft-register/FilterGroup"));
const FilterGroupMobile_1 = __importDefault(require("../components/aircraft-register/FilterGroupMobile"));
const AircraftList_1 = __importDefault(require("../components/aircraft-register/AircraftList"));
const Pagination_1 = __importDefault(require("../components/aircraft-register/Pagination"));
const moment_1 = __importDefault(require("moment"));
/*

x implementer sortering
x multichoice pulldown blir ikke nullstilt
x synlige filtere må fortsatt være først når alle vises
x sortering default bør være registreringsdato
x X i søkefelt kaller ikke reset
x "eier / kontakt" bør vises i en rad over eier
X endre filter tab til aktiv farge også når den bare er ekspandert
X nullstill range slider

x Hover over luftfartøy kort - reg merke blir rødt
X lik spacing under / over søkeord
- luftdyktighetskategori
  - duplisert "Normal"
  - ikke aktiv ved start


MOBIL

- vis filter og sorter sammen
- mobilvisning av eier må være på rekke og rad
- illustrasjon må være riktig på mobilvisning
- filter group må lukke / vises som hel gruppe
- nullstille alle filtre sammen
*/
const TIMESTAMP = "utTimestamp";
const PAGESIZE = "pageSize";
const SEARCHTXT = "searchText";
exports.CALL_API = 0;
exports.READY = 1;
const gridView = "aircraft-grid-view-container";
const listView = "aircraft-list-view-container";
let params = {};
let sortByDefault = "Mark";
const AircraftRegisterPage = (props) => {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    const [searchText, setSearchText] = (0, react_1.useState)(props.labels["searchText"]);
    const [registerData, setRegisterData] = (0, react_1.useState)({ data: undefined });
    const [status, setStatus] = (0, react_1.useState)(exports.CALL_API);
    const [listViewType, setListViewType] = (0, react_1.useState)(gridView);
    let searchURL = props.apiURL;
    (0, react_1.useEffect)(() => {
        if (status === exports.CALL_API) {
            if (searchText !== props.labels["searchText"]) {
                params.searchText = searchText;
            }
            axios_1.default
                .post(searchURL, params)
                .then((response) => {
                setStatus(exports.READY);
                setRegisterData({ data: response.data });
            })
                .catch((error) => console.error(error));
        }
    });
    const submit = (filterState) => {
        if (filterState) {
            if (typeof filterState === "object")
                Object.keys(filterState).forEach((key) => {
                    let filter = filterState[key];
                    if (params[key] && (!filter.value || !filter.active))
                        delete params[key];
                    if (filter.value && filter.active)
                        params[key] = filter.value;
                });
            // reset pagination
            params.pageNumber = 0;
        }
        setStatus(exports.CALL_API);
    };
    const changeSort = (_operation, data) => {
        const sortValue = data.value;
        params.sortBy = sortValue; //data.charAt(0).toLowerCase() + data.substring(1);
        submit("sort");
    };
    const changePagination = (pageNumber) => {
        params.pageNumber = pageNumber;
        submit();
    };
    const scrollUp = () => {
        window.scrollTo({
            top: 0,
            behavior: "auto",
        });
    };
    return ((0, jsx_runtime_1.jsxs)("div", { className: "o-aircraft-register", children: [(0, jsx_runtime_1.jsxs)("div", { className: "row justify-content-center", children: [(0, jsx_runtime_1.jsx)("h1", { className: "col-lg-8 text-lg-center", children: props.textHeading }), (0, jsx_runtime_1.jsxs)("div", { className: "col-lg-6 col-md-7", children: [(0, jsx_runtime_1.jsx)("p", { className: "lead a-text-lead", children: props.textIntro }), (0, jsx_runtime_1.jsx)("p", { className: "a-main-content", children: (0, jsx_runtime_1.jsx)("span", { dangerouslySetInnerHTML: { __html: (_a = props.textRich) !== null && _a !== void 0 ? _a : "" } }) }), (0, jsx_runtime_1.jsxs)("p", { className: "lead a-text-lead last-updated", children: ["Sist oppdatert\u00A0", (0, jsx_runtime_1.jsx)("span", { id: "index-timestamp", children: props.timestamp ? (0, moment_1.default)(props.timestamp).format("DD.MM.YYYY") : "" })] })] })] }), (0, jsx_runtime_1.jsx)("div", { className: "row col-12 col-lg-10 offset-lg-1 mb-3 a-background-box a-background-box--blue", children: (0, jsx_runtime_1.jsx)(SearchBar_1.default, { value: searchText, submitOnEnter: true, onChange: setSearchText, clearInitialValue: true, onSubmit: () => {
                        setStatus(exports.CALL_API);
                    }, onReset: (ev) => {
                        ev.preventDefault();
                        setSearchText("");
                        setStatus(exports.CALL_API);
                    }, onSubmitEnter: () => {
                        setStatus(exports.CALL_API);
                    } }) }), (0, jsx_runtime_1.jsx)("div", { className: "col-12 col-lg-10 offset-lg-1 mb-4", children: params.searchText && ((0, jsx_runtime_1.jsxs)("div", { className: "search-term mb-2", children: ["'", params.searchText, "'", (0, jsx_runtime_1.jsx)("button", { className: "search-term-reset", onClick: (ev) => {
                                ev.preventDefault();
                                setSearchText("");
                                setStatus(exports.CALL_API);
                            }, "aria-label": "Clear search", children: (0, jsx_runtime_1.jsx)("svg", { width: "14", height: "14", viewBox: "0 0 14 14", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-hidden": "true", children: (0, jsx_runtime_1.jsx)("path", { d: "M13.58 0.42C13.02 -0.14 12.18 -0.14 11.62 0.42L7 5.04L2.38 0.42C1.82 -0.14 0.98 -0.14 0.42 0.42C-0.14 0.98 -0.14 1.82 0.42 2.38L5.04 7L0.42 11.62C-0.14 12.18 -0.14 13.02 0.42 13.58C0.7 13.86 0.98 14 1.4 14C1.82 14 2.1 13.86 2.38 13.58L7 8.96L11.62 13.58C11.9 13.86 12.32 14 12.6 14C12.88 14 13.3 13.86 13.58 13.58C14.14 13.02 14.14 12.18 13.58 11.62L8.96 7L13.58 2.38C14.14 1.82 14.14 0.98 13.58 0.42Z", fill: "#F06C00" }) }) })] })) }), (0, jsx_runtime_1.jsxs)("menu", { className: "search-menu col-lg-10 offset-lg-1", children: [(0, jsx_runtime_1.jsx)("div", { className: "filter-group-container", children: (0, jsx_runtime_1.jsx)(FilterGroup_1.default, { filters: props.filters, labels: props.labels, submit: submit }) }), (0, jsx_runtime_1.jsxs)("div", { className: "search-menu-container", children: [(0, jsx_runtime_1.jsxs)("div", { className: "view-options-and-sort", children: [(0, jsx_runtime_1.jsx)("button", { className: "search-result-view-button", onClick: () => {
                                            setListViewType(gridView);
                                        }, "aria-label": "Grid view", children: (0, jsx_runtime_1.jsx)("img", { src: listViewType === gridView
                                                ? "/Resources/icons/grid-view-selected.svg"
                                                : "/Resources/icons/grid-view.svg", alt: "", "aria-hidden": "true" }) }), (0, jsx_runtime_1.jsx)("button", { className: "search-result-view-button", onClick: () => {
                                            setListViewType(listView);
                                        }, "aria-label": "List view", children: (0, jsx_runtime_1.jsx)("img", { src: listViewType === listView
                                                ? "/Resources/icons/list-view-selected.svg"
                                                : "/Resources/icons/list-view.svg", alt: "", "aria-hidden": "true" }) }), (0, jsx_runtime_1.jsxs)("div", { className: "search-sort-container", children: [(0, jsx_runtime_1.jsx)(FilterGroupMobile_1.default, { filters: props.filters, label: "Filter", labels: props.labels, submit: submit, totalItems: Number((_c = (_b = registerData === null || registerData === void 0 ? void 0 : registerData.data) === null || _b === void 0 ? void 0 : _b.totalItems) !== null && _c !== void 0 ? _c : 0) }), props.sortBy && ((0, jsx_runtime_1.jsx)(FilterSort_1.default, { data: props.sortBy.data, label: "Sorter", default: sortByDefault, changeFilter: changeSort }))] })] }), registerData && registerData.data && registerData.data.items && ((0, jsx_runtime_1.jsx)("div", { className: "search-result row", children: (0, jsx_runtime_1.jsxs)("div", { className: "menu-search-numbers", children: ["viser ", registerData.data.items.length, " av ", registerData.data.totalItems, " luftfart\u00F8y"] }) }))] })] }), registerData && registerData.data && registerData.data.items && ((0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)(AircraftList_1.default, { data: registerData.data.items, searchParams: params, listViewType: listViewType }), registerData && registerData.data && registerData.data.items && ((0, jsx_runtime_1.jsxs)("div", { className: "result-bottom-view", children: ["Du har sett ", registerData.data.items.length, " av ", registerData.data.totalItems, " ", "luftfart\u00F8y"] })), registerData &&
                        registerData.data &&
                        Number((_d = registerData.data.totalItems) !== null && _d !== void 0 ? _d : 0) > Number((_e = params.pageSize) !== null && _e !== void 0 ? _e : 0) && ((0, jsx_runtime_1.jsx)("div", { className: "o-aircraft-register-pagination", children: (0, jsx_runtime_1.jsx)(Pagination_1.default, { data: { data: { totalItems: Number((_f = registerData.data.totalItems) !== null && _f !== void 0 ? _f : 0) } }, params: {
                                pageNumber: Number((_g = params.pageNumber) !== null && _g !== void 0 ? _g : 0),
                                pageSize: Number((_h = params.pageSize) !== null && _h !== void 0 ? _h : 0),
                            }, changePagination: changePagination }) }))] })), (0, jsx_runtime_1.jsx)("div", { className: "scroll-up", children: (0, jsx_runtime_1.jsx)("button", { onClick: scrollUp, className: "scroll-to-top-button", children: "Til toppen" }) })] }));
};
const findFilter = (filters, name) => {
    let filter = undefined;
    filters.forEach((f) => {
        if (f.name === name)
            filter = f;
    });
    let index = filter ? filters.indexOf(filter) : -1;
    if (index > -1)
        filters.splice(index, 1);
    return filter;
};
const parseData = (appRootNode) => {
    var _a, _b, _c, _d, _e, _f, _g;
    const data = { filters: [], labels: {} };
    try {
        const appData = appRootNode.getAttribute("data-react-props");
        data.apiURL = appData !== null && appData !== void 0 ? appData : "";
        const dataPropsNodeID = "data-props";
        const dataPropsNode = document.getElementById(dataPropsNodeID);
        if (!dataPropsNode)
            console.warn(`${dataPropsNodeID} node not found`);
        else {
            data.textHeading = (_a = dataPropsNode.getAttribute("data-heading")) !== null && _a !== void 0 ? _a : undefined;
            data.textIntro = (_b = dataPropsNode.getAttribute("data-intro")) !== null && _b !== void 0 ? _b : undefined;
            data.textRich = (_c = dataPropsNode.getAttribute("data-rich")) !== null && _c !== void 0 ? _c : undefined;
            let labelStrings = dataPropsNode.getAttribute("data-translations");
            data.labels = labelStrings ? JSON.parse(labelStrings) : {};
            data.labels = (_d = data.labels) !== null && _d !== void 0 ? _d : {};
            data.labels["mainOwner"] = "Eier";
            let filterStrings = dataPropsNode.getAttribute("data-filter-range");
            let parsedData = filterStrings ? JSON.parse(filterStrings) : {};
            data.filters = (_e = parsedData.filters) !== null && _e !== void 0 ? _e : [];
            // extract timestamp and page size from filter list
            if (parsedData[TIMESTAMP])
                data.timestamp = parsedData[TIMESTAMP];
            params.pageSize = Number((_f = parsedData[PAGESIZE]) !== null && _f !== void 0 ? _f : 0);
            params.pageNumber = 0;
            params.sortBy = sortByDefault;
            const filters = (_g = data.filters) !== null && _g !== void 0 ? _g : [];
            data.filters = filters;
            const sortBy = findFilter(filters, "sortBy");
            const sortByData = sortBy === null || sortBy === void 0 ? void 0 : sortBy.data;
            if (Array.isArray(sortByData)) {
                data.sortBy = { data: sortByData };
            }
            findFilter(filters, SEARCHTXT);
        }
    }
    catch (err) {
        console.error("parseData() fail", err);
    }
    return data;
};
const renderApp = () => {
    const nodeId = "index-register-root";
    const appRootNode = document.getElementById(nodeId);
    let props;
    if (!appRootNode) {
        console.warn(`Cannot find node with ID '${nodeId}'. The React app cannot be rendered.`);
        return;
    }
    props = parseData(appRootNode);
    (0, client_1.createRoot)(appRootNode).render(react_1.default.createElement(AircraftRegisterPage, props));
};
renderApp();
exports.default = AircraftRegisterPage;
